<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['hotel_bookings.menu'])">
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <h5 class="title-secondary">
        {{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.TITLE' | translate }}
      </h5>
    </div>

    <div class="d-flex align-items-center">
      <div>
        <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
          {{ 'CLEAR_FILTERS' | translate }}
        </button>
      </div>

      <div>
        <app-hotel-bookings-mass-reassign
          *ngIf="accessService.hasAccess([], ['hotel_bookings.mass_reassign_agents'])"
          class="me-2"
        >
        </app-hotel-bookings-mass-reassign>
      </div>

      <div>
        <button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.store']
            )
          "
          type="button"
          class="btn btn-secondary"
          aria-label="Add"
          (click)="add()"
        >
          {{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.ADD' | translate }}
        </button>
      </div>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="hotelBookingsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Hotel_bookings', grid)"
    [rowClass]="bookingRowCallback"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="hotel.name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.HOTEL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('hotel.name')"
      [width]="300"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-hotel-select [filter]="filter"></app-kendo-hotel-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a [routerLink]="'/hotel-bookings/view'" [queryParams]="{ id: dataItem.id }" target="_blank">
          {{ dataItem?.hotel?.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="events"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.EVENTS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('events')"
      [sortable]="false"
      [width]="200"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-select [filter]="filter" [field]="'events.id'"></app-kendo-event-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div *ngFor="let event of dataItem.events; let i = index">
          <a [routerLink]="['/events/view']" [queryParams]="{ id: event.id }" target="_blank">
            {{ event.formattedName }}
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="events.date_from"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.EVENTS_DATES' | translate }}"
      filter="date"
      [hidden]="isHiddenColumn('events_dates')"
      [sortable]="true"
      [width]="200"
    >
      <!--      <ng-template kendoGridFilterCellTemplate let-filter>-->
      <!--        <app-kendo-event-select [filter]="filter" [field]="'events.id'"></app-kendo-event-select>-->
      <!--      </ng-template>-->

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div *ngFor="let event of dataItem.events; let i = index">
          <div>{{ event.date_from }}</div>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="supplier_id"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.SUPPLIER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('supplier_id')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-supplier-select [filter]="filter"></app-kendo-supplier-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.supplier?.name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="company.name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.COMPANY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter"></app-kendo-company-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/settings/companies/view']" [queryParams]="{ id: dataItem?.company_id }" target="_blank">
          {{ dataItem?.company?.shortName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="property.value"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.PROPERTY' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('property.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select
          [groupType]="'booking_properties'"
          [field]="'property_id'"
          [filter]="filter"
        ></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.property"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="commission_percent"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.COMMISSION_PERCENT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('commission_percent', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="ref_number"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.REF_NUMBER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('ref_number')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="rooms.ref_number"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.ROOMS_REF_NUMBER' | translate }}"
      filter="text"
      [sortable]="false"
      [hidden]="isHiddenColumn('rooms.ref_number')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-filter>
        <ng-container *ngIf="roomRefNumFilter">
          <div *ngFor="let refNum of dataItem?.roomsRefNumber; let i = index">
            {{ refNum }}
          </div>
        </ng-container>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="cancellation_deadline"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.CANCELLATION_DEADLINE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('cancellation_deadline')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.cancellation_deadline | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="payment_deadline"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.PAYMENT_DEADLINE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('payment_deadline')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.payment_deadline | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [hidden]="isHiddenColumn('created_at', true)"
      field="created_at"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="total_amount"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.TOTAL_AMOUNT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('total_amount')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.total_amount | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="balance"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.BALANCE' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('balance')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span
          class="fw-bold"
          [ngClass]="{ 'theme-color-danger': dataItem.balance > 0, 'theme-color-success': dataItem.balance <= 0 }"
        >
          {{ dataItem.balance | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="available_nights_count"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('available_nights_count', true)"
    >
      <ng-template kendoGridHeaderTemplate>
        {{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.AVAILABLE_NIGHTS_COUNT' | translate }}
        <i class="fas fa-moon nights-ico"></i>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="cancellations_count"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.CANCELLATIONS_COUNT' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('cancellations_count', true)"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/hotel-booking-cancellations']" [queryParams]="{ booking_id: dataItem.id }">
          {{ dataItem.cancellations_count }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="breakfast_price_per_night"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.BREAKFAST_PRICE_PER_NIGHT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('breakfast_price_per_night', true)"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.breakfast_price_per_night }}
        <app-currency-box [currency]="dataItem.breakfast_price_per_night_currency"></app-currency-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="tags"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.TAGS' | translate }}"
      filter="text"
      [sortable]="false"
      [hidden]="isHiddenColumn('tags', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <app-kendo-tag-select [filter]="filter" [model]="LaravelModelsEnum.HOTELBOOKING"></app-kendo-tag-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span *ngFor="let tag of dataItem?.tags; let i = index">
          {{ tag }}<span *ngIf="i !== dataItem?.tags?.length - 1">, </span>
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="rooms.type.value"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.ROOMS_TYPE' | translate }}"
      [hidden]="isHiddenColumn('rooms.type.value', true)"
      [sortable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'rooms'" [filter]="filter" [field]="'rooms.type_id'">
        </app-kendo-type-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge
          *ngFor="let type of dataItem?.roomsUniqueTypes; let i = index"
          [type]="type"
          class="d-block"
        ></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="contracting_agent.fake_first_name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.CONTRACTING_AGENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('contracting_agent.fake_first_name', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.CONTRACTING_AGENT]"
          [field]="'contracting_agent_id'"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.contracting_agent?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="reservation_agent.fake_first_name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.RESERVATION_AGENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('reservation_agent.fake_first_name', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.RESERVATION_AGENT]"
          [field]="'reservation_agent_id'"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.reservation_agent?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="amendment_agent.fake_first_name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.AMENDMENT_AGENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('amendment_agent.fake_first_name', false)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.AMENDMENT_AGENT]"
          [field]="'amendment_agent_id'"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.amendment_agent?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="show_to_web"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.SHOW_TO_WEB' | translate }}"
      filter="boolean"
      [width]="100"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('show_to_web')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.show_to_web"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="assign_date"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.ASSIGN_DATE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('assign_date', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.assign_date | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.show']
            )
          "
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-preview-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              ['hotel_bookings.show']
            )
          "
          [link]="['/hotel-bookings/view']"
          [params]="{ id: dataItem.id }"
        >
        </app-preview-button>

        <a
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_booking_cancellations.store']
            )
          "
          class="btn btn-warning btn-ico"
          [routerLink]="['/hotel-booking-cancellations/view']"
          [queryParams]="{ booking_id: dataItem.id }"
          [ngbTooltip]="'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.CREATE_CANCELLATION' | translate"
          container="body"
        >
          <i class="fal fa-ban"></i>
        </a>

        <app-download-rooming-list-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.export_sold_rooms']
            )
          "
          [bookingId]="dataItem?.id"
          [iconButton]="true"
        >
        </app-download-rooming-list-button>

        <app-payment-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['payments.store']
            )
          "
          [paymentable_id]="dataItem.id"
          [paymentable_type]="LaravelModelsEnum.BOOKING"
          (close)="loadData(state)"
        >
        </app-payment-button>

        <app-media-library-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['media.index']
            )
          "
          [ngbTooltip]="'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.UPLOAD_DOCUMENTS' | translate"
          container="body"
          [icon]="'fal fa-file'"
          [acceptType]="MediaLibraryAcceptTypes.ALL"
          [collectionName]="'documents'"
          [modelId]="dataItem.id"
          [modelType]="LaravelModelsEnum.BOOKING"
        >
        </app-media-library-button>

        <app-delete-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.destroy']
            )
          "
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
